import { Injectable } from '@angular/core';
import { UserService } from 'src/api/services/user.service';
import { User,Customer } from 'src/api/models';
import { BehaviorSubject, Observable } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class UserTableService {

    public remoteData: Observable<User[]>;
    private _remoteData: BehaviorSubject<User[]>;
    public results: User[];
    public loading: boolean;
    public searchFilter: string;

    constructor(private readonly service: UserService, private toasterService: ToastrService) {
      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
    }

    get() {
      this.loading = true;
      this.service.UserGetAllUsers().subscribe(results => {
        this.loading = false;
        this.results = results;
        this._remoteData.next(results);
      });
    }

    /*add(user: User) : Observable<User> {
      return this.service.UserCreateNewUser(user)
    }*/

    filter(filter: string, customer:Customer){
      //users.filter(user => );
      console.log("USER FILTER");
      if (!filter) filter = "";
      const lowerFilter = filter.toLowerCase();
      if (customer) this._remoteData.next(this.results.filter(user => user.customerId == customer.customerId && 
        (user.email?.toLowerCase().includes(lowerFilter) || user.displayName?.toLowerCase().includes(lowerFilter))));
      else this._remoteData.next(this.results.filter(user => user.email?.toLowerCase().includes(lowerFilter) || user.displayName?.toLowerCase().includes(lowerFilter)));
    }

    remove(user: User){
      this.loading = true;
      return this.service.UserDeleteUserByIdResponse(user.userId).subscribe(s => {
        this.toasterService.success("User Removed");
        this.loading = false;
        // find user and remove from this.results
        this.results = this.results.filter(u => u.userId !== user.userId);
        this._remoteData.next(this.results);
        //this.get();
      }, e =>{
        this.toasterService.error("User Not Removed");
        this.loading = false;
      });
    }

    update(user: User){
      this.loading = true;
      return this.service.UserUpdateUser(user).subscribe(s => {
        this.toasterService.success("User Updated");
        this.loading = false;
        const index = this.results.findIndex(u => u.userId === user.userId);
        if (index !== -1) {
          this.results[index] = s;
          this._remoteData.next([...this.results]);
        }
      }, e =>{
        this.toasterService.error("User Not Updated");
        this.loading = false;
      });
    }

    add(user : User){
      this.loading = true;
      return this.service.UserCreateNewUser(user).subscribe(s => {
        this.toasterService.success("User Added");
        this.loading = false;
        this.results.push(s);
        this._remoteData.next(this.results);
      }, e =>{
        this.toasterService.error("User Not Added");
        this.loading = false;
      });
    }
}
